import styled from 'styled-components';

export const ContainerLoja = styled.div`
  width: 100%;
  padding: 0 1.5rem;
`;

export const ContentLoja = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 20px 0;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const SettingsCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  svg {
    color: #3b82f6;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
`;

export const LojaInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.5rem;

  label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #475569;
  }

  input,
  .rs-picker-toggle,
  .rs-input,
  .rs-input-group {
    border: 1px solid #cbd5e1 !important;
    background-color: #f8fafc !important;
    border-radius: 6px !important;
    transition: all 0.2s ease-in-out;
  }

  input:focus,
  .rs-picker.rs-picker-focused .rs-picker-toggle,
  .rs-input:focus,
  .rs-input-group.rs-input-group-focus {
    border-color: #3b82f6 !important;
    background-color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15) !important;
    outline: none;
  }
`;

export const InputsLojaWrapper = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  & > div {
    flex: 1;
    min-width: 120px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;
